<template lang="pug">
.card.mt-2
  .card-header
    .card-title.h6.text-primary Integração
    small.card-subtitle.text-gray Informe os dados para integração caso necessário
  .card-body
    form-group(label="ID da Unidade SEI")
      sei-todas-unidades-picker(v-model="value.IdUnidadeSEI")
      .abbr Informe o ID da Unidade SEI para integrar ao encerrar a OS-m
</template>

<script>
export default {
  props: { value: { type: Object, default: () => {} } },
}
</script>
